'use client';

import { useTranslation } from '@/hooks/useTranslation';
import { deliveryRequestApi, type DeliveryRequest } from '../_lib/api';
import { Badge, SimpleListPage } from '../_lib/SimpleListPage';

const STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  REQUESTED: { bg: '#fff7e8', text: '#ff7d00' },
  APPROVED: { bg: '#e8f3ff', text: '#3370ff' },
  FULFILLING: { bg: '#fff8e6', text: '#d4a017' },
  COMPLETED: { bg: '#e6fff0', text: '#0fc66e' },
  CANCELLED: { bg: '#ffece8', text: '#f53f3f' },
};

export default function DeliveriesPage() {
  const { t } = useTranslation();
  const rm = t.robotManager;
  const typeLabels = rm.deliveryType as Record<string, string>;
  return (
    <SimpleListPage<DeliveryRequest>
      title={rm.lists.deliveries.title}
      description={rm.lists.deliveries.description}
      load={async (p) => (await deliveryRequestApi.list(p)).items}
      searchPlaceholder={rm.lists.deliveries.searchPlaceholder}
      columns={[
        { key: 'deliveryNo', label: rm.fields.deliveryNo, width: '180px' },
        { key: 'requestType', label: rm.fields.requestType, width: '140px', render: (d) => typeLabels[d.requestType] ?? d.requestType },
        { key: 'status', label: rm.fields.status, width: '120px', render: (d) => {
          const c = STATUS_COLORS[d.status] ?? { bg: '#f0f0f0', text: '#888' };
          return <Badge text={d.status} bg={c.bg} color={c.text} />;
        } },
        { key: 'expectedDate', label: rm.fields.expectedDate, render: (d) => new Date(d.expectedDate).toLocaleDateString() },
        { key: 'createdAt', label: rm.fields.createdShort, render: (d) => new Date(d.createdAt).toLocaleDateString() },
      ]}
    />
  );
}
